/** Base classname */
export var INFO_OVERLAY_BASE_CLASSNAME = 'ws10-info-overlay';
